var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_92_896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5408 18C13.1621 18 13.6658 17.4963 13.6658 16.875C13.6658 16.2537 13.1621 15.75 12.5408 15.75C11.9195 15.75 11.4158 16.2537 11.4158 16.875C11.4158 17.4963 11.9195 18 12.5408 18Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5408 13.5V12.75C14.1973 12.75 15.5408 11.5744 15.5408 10.125C15.5408 8.67562 14.1973 7.5 12.5408 7.5C10.8842 7.5 9.54077 8.67562 9.54077 10.125V10.5",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5408 21C17.5113 21 21.5408 16.9706 21.5408 12C21.5408 7.02944 17.5113 3 12.5408 3C7.57021 3 3.54077 7.02944 3.54077 12C3.54077 16.9706 7.57021 21 12.5408 21Z",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92_896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.540771)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.2fb34e2c54ccbbce5a57e0201ce6dc4c.svg";
export { ForwardRef as ReactComponent };